module.exports = __webpack_public_path__ + "static/media/shiftshave-5.3d8b56f5.jpg";